import { getOrganizationMembers } from './api/organizations';
import { userStore } from '~/lib/stores/user';
import type { OrganizationData } from '~/types/organization';

export const getSortedOrgMembers = async (organization: OrganizationData) => {
  const user = userStore.user.get();

  const members = await getOrganizationMembers({ organization });

  // we always put current user on top
  const sortedMembers = members.sort((member) => {
    if (member.user.username === user?.username) {
      return -1;
    }

    return 0;
  });

  return sortedMembers;
};
